import React from "react";
import { useEffect } from "react";

export default function HubspotForm({ region, portalId, formId, target }) {
  // Loads hubspot form iframe
  // TODO: In the future, we should use the api instead
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    // Mailing List Signup Form
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: region,
          portalId: portalId,
          formId: formId,
          // TODO: Does target need to be unique? (multiple forms on one page?)
          target: `#${target}`,
        });
      }
    });
  }, []);

  return <div id={target}></div>;
}
